/**
 * Feature Capabilities Admin Page
 *
 * Admin interface for managing organization feature capabilities:
 * - Enable/disable modular features for organizations
 * - Configure display behavior for disabled features
 * - View capability status across categories
 */

import React from 'react';
import { CapabilitiesManagement } from '@/components/admin/CapabilitiesManagement';
import { Settings } from 'lucide-react';

interface FeatureCapabilitiesPageProps {
  organizationId: number;
  organizationName: string;
  onNavigate?: (tab: string) => void;
}

export default function FeatureCapabilitiesPage({
  organizationId,
  organizationName,
}: FeatureCapabilitiesPageProps) {
  return (
    <div className="max-w-7xl mx-auto py-8 px-4">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <Settings className="w-8 h-8 text-indigo-600" />
          <h1 className="font-display text-2xl font-semibold text-ink">Feature Capabilities</h1>
        </div>
        <p className="text-ink-500">
          Enable or disable modular features and configure display behavior for{' '}
          <span className="font-medium">{organizationName}</span>
        </p>
      </div>

      <CapabilitiesManagement
        organizationId={organizationId}
        organizationName={organizationName}
      />
    </div>
  );
}
